import { render, staticRenderFns } from "./TcoChooseProductRules.vue?vue&type=template&id=0bfe001e"
import script from "./TcoChooseProductRules.vue?vue&type=script&lang=js"
export * from "./TcoChooseProductRules.vue?vue&type=script&lang=js"
import style0 from "./TcoChooseProductRules.vue?vue&type=style&index=0&id=0bfe001e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports